export const agent = {
  yqmh: "Mời hộp mù",
  yqzmh: "Mời để kiếm hộp ẩn",
  bfbkj: "100% giải thưởng rút thăm",
  yqpy: "Mời bạn bè",
  pywczcrw: "Bạn bè đăng ký và hoàn thành nhiệm vụ",
  hdcmhcs: "Lấy số lượng hộp rút thăm ẩn",
  jllb: "Danh sách phần thưởng",
  mhjlbk: "Phần thưởng hộp ẩn có thể bao gồm: {text} Số tiền cụ thể tùy thuộc vào phần thưởng thực tế nhận được!",
  kkcs: "Có thể mở {value} lần",
  mhmx: "Chi tiết hộp mù",
  jpmx: "Chi tiết giải thưởng",
  hdmhs: "Số lượng hộp mù đã thu được",
  hyjd: "Tiến trình của bạn bè",
  jplx: "Loại giải thưởng",
  dbmc: "Tên mã thông báo",
  ypf: "Phân phối",
  wpf: "Chưa gửi",
  lq: "Nhận",
  zblw: "Món quà xung quanh",
  gxczmh: "Xin chúc mừng vì đã trúng {amount}, hãy mời bạn bè mới, hoàn thành nhiệm vụ và nhận được hộp quà",
  lxkflq: "Vui lòng liên hệ với bộ phận chăm sóc khách hàng để nhận phần thưởng quà tặng ngoại vi",
  shdz: "địa chỉ giao hàng",
  rwmc: "Tên nhiệm vụ",
  wczt: "Trạng thái hoàn thành",
  hdmhsl: "Lấy số lượng hộp mù",
  zblqdz: "Địa chỉ nhận hàng gần đó",
  shr: "Người nhận hàng",
  dh: "điện thoại",
  xxdz: "Địa chỉ chi tiết",
  yqmhhdgz: "Quy tắc hoạt động hộp mời ẩn",
  yqyl: "1. Quà tặng mời Biking là gì?",
  yhhkxt: "Quà tặng mời tham gia Biking là hệ thống phản hồi của người dùng Biking, nhằm mục đích tri ân tất cả người dùng trung thành đã biết đến Biking và mời bạn bè tham gia Biking.",
  yqhyhdfhjl: "Quà tặng mời Biking rất đơn giản và dễ sử dụng. Người dùng chỉ cần mời bạn bè để nhận được phần thưởng phong phú.",
  cyhdhqjl: "Thứ hai, tôi có thể nhận được phần thưởng gì khi tham gia sự kiện và hoàn thành nhiệm vụ?",
  hywcrwhdjl: "Người mời mời bạn bè và bạn bè hoàn thành các nhiệm vụ tương ứng. Cả người mời và người được mời đều có thể nhận được hộp ẩn và mở hộp ẩn để nhận phần thưởng.",
  mhhdgz: "3. Quy tắc để có được hộp mù",
  syrwczc: "1. Người được mời hoàn tất đăng ký và xác minh tên thật - người được mời có một cơ hội để kích hoạt tài khoản",
  syrcz: "2. Người được mời gửi tiền ≥ 100 USDT - người mời và người được mời đều có 1 cơ hội mở tài khoản",
  syrcssxf: "3. Phí hợp đồng của người được mời là ≥30USDT - người mời và người được mời mỗi người có 2 cơ hội mở",
  qqjyl: "4. Khối lượng giao dịch quyền chọn ≥ 200 USDT - người mời và người được mời đều có 2 cơ hội mở lệnh",
  yxjyl: "5. Khối lượng giao dịch Gamefi ≥ 200 USDT và tỷ lệ cược không dưới 1,2 lần, các lệnh có tỷ lệ cược dưới 1,2 lần sẽ không được tính - người mời và người được mời mỗi người được 2 cơ hội mở lệnh",
  xhmrjyl: "6. Khối lượng giao dịch mua giao ngay ≥ 500 USTD - người mời và người được mời đều có 1 cơ hội mở bán",
  rwqbwc: "Nếu tất cả nhiệm vụ mời được hoàn thành mỗi lần, người mời có thể có tới 8 cơ hội mở hộp ẩn và nếu tất cả người được mời hoàn thành các nhiệm vụ này, họ có thể có tới 9 cơ hội mở hộp ẩn. Mời nhiều người và cơ hội nhận được hộp ẩn sẽ tăng dần theo quy tắc.",
  qtsm: "4. Các hướng dẫn khác",
  mhffsj: "1. Thời gian phân phối hộp mù - làm mới sau mỗi 10 phút",
  jlffsj: "2. Thời gian phân phối phần thưởng - hệ thống sẽ phân phối phần thưởng một lần một ngày vào lúc 12 giờ trưa",
  syyhjkcj: "3. Tất cả người dùng đều có thể tham gia và không xung đột với các hoạt động khác",
  mhcjs: "4. Số lượng lượt rút thăm ngẫu nhiên sẽ được thiết lập lại vào ngày 1 hàng tháng",
  yqmts: "Chỉ mời người dùng trở thành cấp dưới và các giao dịch cấp dưới sẽ tạo ra hoa hồng cho bạn",
  fym: "mã giảm giá",
  fymts: "Mời và trực tiếp mở tỷ lệ hoàn tiền cho người dùng cấp dưới không cao hơn tỷ lệ của bạn và các giao dịch cấp dưới sẽ được phân bổ hoa hồng theo tỷ lệ",
  szfym: "Đặt mã giảm giá",
  xzfym: "Thêm mã giảm giá mới",
  lj: "Liên kết",
  fybl: "Tỷ lệ hoàn tiền",
  yyqhys: "Số lượng bạn bè được mời",
  sykcjs: "Phần còn lại có thể được tạo ra",
  tjlx: "Loại được đề xuất",
  bwjs: "5. Nếu bất kỳ cá nhân hoặc nhóm nào bị phát hiện tham gia vào các lợi ích hộp mù, CoinKing có quyền khấu trừ hoặc hủy bỏ điều kiện hưởng lợi của tài khoản. Tất cả người dùng tham gia vào lợi ích này được coi là đã chấp nhận các điều khoản lợi ích chính thức và CoinKing Exchange có quyền giải thích cuối cùng.",
  swmr: "Đặt làm mặc định",
  cffym: "Mã hoàn tiền đã lặp lại, vui lòng nhập mã hoàn tiền chính xác",
  qxtjfym: "Vui lòng thêm mã giảm giá trước",
  xywdbl: "10 <= tỷ lệ hoàn tiền của tôi",
  qsrdybl: "Vui lòng nhập tỷ lệ tương ứng",
  qsrzqsl: "Vui lòng nhập giá trị chính xác",
  qsrbz: "Vui lòng nhập nhận xét",
  bnbhzf: "Không được chứa ký tự đặc biệt hoặc biểu tượng cảm xúc",
  pfjj: "Phân phối bị từ chối",
  pfsb: "Phân phối phần thưởng không thành công",
  lxkf: "Vui lòng liên hệ với bộ phận dịch vụ khách hàng để biết chi tiết",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/vi.js